<template>
  <div class="resource">
    <div class="title-container">资源管理</div>
    <div class="search-container">
      <el-form ref="form" :model="queryParams" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="queryParams.name" @keypress.native.enter="searchHandle" placeholder="输入资源名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchHandle">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="resource-container">
      <div class="mg-bottom16">
        <el-button type="primary" size="small" @click="createResource">创建资源</el-button>
      </div>
      <div class="table-container">
        <el-table :data="tableData" border v-loading="listLoading">
          <el-table-column prop="code" label="资源编码" min-width="120"></el-table-column>
          <el-table-column prop="name" label="资源名称" min-width="120"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" min-width="160"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="resourceAuthorize(scope.row)">授权</el-button>
              <el-button type="text" size="medium" @click="editResource(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-container text-align-right">
        <Pagination v-bind:child-msg="pageParams" @pageChange="pageChange"/>
      </div>
    </div>
    <div v-if="resourceDialog">
      <el-dialog :title="dialogTitle" :visible.sync="resourceDialog" width="580px" @close="closeResourceHandle">
        <div class="resourceForm-content">
          <el-form ref="resourceForm" :model="resourceForm" :rules="rules" label-width="85px" label-position="left">
            <el-form-item label="资源编码：" prop="code">
              <el-input v-if="resourceId" v-model="resourceForm.code" placeholder="请输入资源编码" disabled></el-input>
              <el-input v-else v-model="resourceForm.code" placeholder="请输入资源编码"></el-input>
            </el-form-item>
            <el-form-item label="资源名称：" prop="name">
              <el-input v-model="resourceForm.name" placeholder="请输入资源名称"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="resourceForm.remark" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="resourceDialog = false">取 消</el-button>
          <el-button type="primary" size="small" :loading="loading" @click="resourceHandle">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="authorizeDialog">
      <el-dialog :title="dialogTitle" :visible.sync="authorizeDialog" width="1085px">
        <div class="resourceForm-content">
          <div class="orginForm-content">
            <el-form :model="authorizeParams" >
              <el-form-item >
                <el-checkbox-group v-model="authorizeParams.api_ids">
                  <el-checkbox border v-for="(item, index) of authorizeData" :key="index" :label="item.id">{{ item.title}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
<!--          <el-tree-->
<!--            :data="authorizeData"-->
<!--            show-checkbox-->
<!--            node-key="id"-->
<!--            :default-checked-keys="defaultChecked"-->
<!--            @node-click="handleNodeClick"-->
<!--            @check-change="handleCheckChange"-->
<!--            :props="defaultProps"-->
<!--            ref="resourceTree">-->
<!--          </el-tree>-->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="authorizeDialog = false">取 消</el-button>
          <el-button type="primary" :loading="loading" size="small" @click="authorizeHandle">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import resourceApi from '@/api/system/resource'
  import interfaceApi from '@/api/system/interface'
  import Pagination from '@/components/Pagination'

  export default {
    name: 'resource',
    data() {
      return {
        listLoading: false,
        // 查询参数
        queryParams: {
          page: 1,
          per_page: 10
        },
        pageParams: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        tableData: [],
        dialogTitle: '',
        resourceId: '',
        resourceDialog: false,
        resourceForm: {},
        authorizeData: [],
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        defaultChecked: [],
        authorizeDialog: false,
        rules: {
          code: [
            { required: true, message: '资源编码不能为空', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '资源名称不能为空', trigger: 'blur' }
          ]
        },
        authorizeParams: {
          api_ids: []
        },
        authorizeId: '',
        loading: false
      }
    },
    created() {
      this.getTableData()
    },
    components: {
      Pagination
    },
    methods: {
      getTableData() {
        this.listLoading = true
        this.queryParams.page = this.pageParams.currentPage
        this.queryParams.per_page = this.pageParams.pageSize
        resourceApi.getList(this.queryParams).then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list
            this.pageParams.total = res.data.total
          }
          this.listLoading = false
        }).catch((res) => {
          this.listLoading = false
        })
      },
      createResource() {
        this.resourceForm = {}
        this.dialogTitle = '创建资源'
        this.resourceDialog = true
      },
      editResource(data) {
        this.dialogTitle = '编辑资源'
        this.resourceId = data.id
        this.resourceForm = data
        // this.getResourceDetail(this.resourceId)
        this.resourceDialog = true
      },
      resourceHandle() {
        this.$refs['resourceForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            if (this.resourceId) {
              let editParams = {
                name: this.resourceForm.name,
                remark: this.resourceForm.remark
              }
              console.log(editParams)
              resourceApi.editResource(this.resourceId, editParams).then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg)
                  this.resourceDialog = false
                  this.getTableData()
                }
                this.loading = false
              }).catch((err) => {
                this.loading = false
                console.log(err)
              })
            } else {
              resourceApi.addResource(this.resourceForm).then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg)
                  this.resourceDialog = false
                  this.getTableData()
                }
                this.loading = false
              }).catch((err) => {
                this.loading = false
                console.log(err)
              })
            }
          }
        })
      },
      closeResourceHandle() {
        this.resourceId = ''
        this.resourceForm = {}
        this.$refs['resourceForm'].resetFields()
      },
      getResourceDetail(id) {
        resourceApi.getResourceDetail(id).then(res => {
          if (res.code === 0) {
            this.resourceForm = res.data
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      resourceAuthorize(row) {
        let newApis = []
        row.apis.forEach(item => {
          newApis.push(item.api_id)
        })
        this.defaultChecked = newApis
        this.authorizeId = row.id
        this.authorizeParams.api_ids = this.defaultChecked
        this.dialogTitle = '授权'
        this.getInterface()
        this.authorizeDialog = true
      },
      // 分页
      pageChange(page) {
        console.log(page)
        this.pageParams.currentPage = page.currentPage
        this.pageParams.pageSize = page.pageSize
        this.getTableData()
      },
      searchHandle() {
        this.queryParams.page = 1
        this.pageParams.currentPage = 1
        this.getTableData()
      },
      // 获取接口列表
      getInterface() {
        let interfaceParams = {
          page: 1,
          per_page: 999
        }
        interfaceApi.getInterface(interfaceParams).then(res => {
          if (res.code === 0) {
            this.authorizeData = res.data.list
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      // 解决el-tree点击文字也能选中复选框的问题
      // handleNodeClick(data) {
      //   const index = this.defaultChecked.findIndex(d => d === data.id)
      //   if (index > -1) {
      //     this.$refs.resourceTree.setChecked(data, false)
      //   } else {
      //     this.$refs.resourceTree.setChecked(data, true)
      //   }
      // },
      // handleCheckChange(data, checked, indeterminate) {
      //   if (checked) {
      //     this.defaultChecked.push(data.id)
      //   } else {
      //     const index = this.defaultChecked.findIndex(d => d === data.id)
      //     this.defaultChecked.splice(index, 1)
      //   }
      //   this.authorizeParams.api_ids = this.defaultChecked
      // },
      // 授权
      authorizeHandle() {
        this.loading = true
        resourceApi.authorize(this.authorizeId, this.authorizeParams).then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.authorizeDialog = false
            this.getTableData()
          }
          this.loading = false
        }).catch((err) => {
          this.loading = false
          console.log(err)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.scss";

  .resourceForm-content {
    .el-form-item:last-child {
      margin-bottom: 0;
    }
  }
  ::v-deep .el-checkbox-group{
    .el-checkbox{
      width: 225px;
      margin-bottom: 16px;
      &:first-child{
        margin-left: 10px;
      }
      &:nth-child(4n){
        margin-right: 0;
      }
    }
  }
</style>
